import { useMemo } from 'react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import { type EnabledTabs, TAB_FEATURE_FLAGS } from '../constants/intakeTabs';

/**
 * Hook to get enabled intake tabs based on feature flags.
 */
export function useEnabledTabs(): Required<EnabledTabs> {
  const { hasFeatureFlag } = useStore(
    useShallow(state => ({
      hasFeatureFlag: state.hasFeatureFlag,
    }))
  );

  return useMemo(
    () => ({
      extraction: true,
      eligibility: hasFeatureFlag(TAB_FEATURE_FLAGS.eligibility!),
      prior_auth: hasFeatureFlag(TAB_FEATURE_FLAGS.prior_auth!),
      ready_to_call: hasFeatureFlag(TAB_FEATURE_FLAGS.ready_to_call!),
      scheduling: hasFeatureFlag(TAB_FEATURE_FLAGS.scheduling!),
      push_to_emr: hasFeatureFlag(TAB_FEATURE_FLAGS.push_to_emr!),
    }),
    [hasFeatureFlag]
  );
}
